import { z } from "zod/v4";

import { WidgetCategoryList, WidgetDtoSchema } from "./widgets";

export const UserInterfaceDtoSchema = z.object({
  id: z.uuid(),
  isEnabled: z.boolean().optional(),
  isArchived: z.boolean().default(false),
  widget: WidgetDtoSchema.optional(),
  widgetId: z.string(),
  category: z.enum(WidgetCategoryList).optional(),
  variationId: z.uuid().nullish(),
  desktopVariables: z.any().nullish(),
  mobileVariables: z.any().nullish(),
  styleOverrides: z.any().nullish(),
});

export type UserInterfaceDto = z.infer<typeof UserInterfaceDtoSchema>;

export const OfferQuantityButtonSchema = z.object({
  id: z.uuid(),
  quantity: z.number().default(1),
  unitName: z.string().default("units"),
  extraMessage: z.string().nullish(), // TODO - CP no longer used in new buttons
  fullPriceMessage: z.string().nullish(), // TODO - CP no longer used in new buttons
  buttonTitle: z.string().nullish(),
  subtitle: z.string().nullish(),
  label: z.string().nullish(),
  badge: z.string().nullish(),
  showCompareAtPrice: z.boolean().default(false).optional(),
  image: z.string().nullish(),
  freeShipping: z
    .object({
      freeShippingLabel: z.string().nullish(),
      showOnlyWhenButtonSelected: z.boolean().default(false),
      hide: z.boolean().default(false),
    })
    .nullish(),
  freeGift: z
    .object({
      freeGiftLabel: z.string().nullish(),
      showOriginalPrice: z.boolean().default(false),
      showOnlyWhenButtonSelected: z.boolean().default(false),
      freeGiftImage: z.string().nullish(),
      hide: z.boolean().default(false),
    })
    .nullish(),
});
export type OfferQuantityButtonType = z.infer<typeof OfferQuantityButtonSchema>;
